export const spanishChannel = 'Live_ESP';
export const pattrnChannel = 'Live_Pattrn';
export const regularChannel = 'Live';
export const anfExtension = '-ANF';

type getContentLibraryArgs = {
  isANF: boolean;
  isSpanish: boolean;
  isLivePattrn: boolean;
  isLive: boolean;
  episode?: string | null;
};

export const getContentLibrary = ({ isANF, isSpanish, isLivePattrn, isLive, episode }: getContentLibraryArgs) => {
  if (!isLive && !isANF) {
    return episode ? 'Movie' : 'VOD';
  }

  let contentLibrary = '';

  if (isSpanish) {
    contentLibrary = spanishChannel;
  } else if (isLivePattrn) {
    contentLibrary = pattrnChannel;
  } else {
    contentLibrary = regularChannel;
  }

  if (isANF) {
    contentLibrary += anfExtension;
  }

  return contentLibrary;
};
